// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/instrument_editor/templates/instrument_controls.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_attrs0 = {
        "class": "instrument-editor"
      },
    marko_attrs1 = {
        "class": "instrument-controls"
      },
    marko_attrs2 = {
        "class": "control-panel"
      },
    marko_attrs3 = {
        "class": "control-group"
      },
    marko_attrs4 = {
        "class": "control"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("afdcbb"),
    marko_node0 = marko_createElement("div", {
        "class": "control"
      }, "7", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("label", {
          "for": "vspeed"
        }, null, null, 1)
        .t("Vibrato Speed")
      .e("input", {
          disabled: true,
          type: "range",
          id: "vspeed",
          min: "0",
          max: "255",
          value: ""
        }, null, null, 0),
    marko_node1 = marko_createElement("div", {
        "class": "control"
      }, "10", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("label", {
          "for": "vdepth"
        }, null, null, 1)
        .t("Vibrato Depth")
      .e("input", {
          disabled: true,
          type: "range",
          id: "vdepth",
          min: "0",
          max: "15",
          value: "0"
        }, null, null, 0),
    marko_node2 = marko_createElement("div", {
        "class": "control"
      }, "13", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("label", {
          "for": "vsweep"
        }, null, null, 1)
        .t("Vibrato Sweep")
      .e("input", {
          disabled: true,
          type: "range",
          id: "vsweep",
          min: "0",
          max: "255",
          value: "0"
        }, null, null, 0),
    marko_node3 = marko_createElement("label", {
        "for": "fadeout"
      }, "5", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Fadeout");

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", marko_attrs0, "0", component);

  out.be("div", marko_attrs1, "1", component);

  out.be("div", marko_attrs2, "2", component);

  if (data.instrument) {
    out.e("div", marko_attrs3, "3", component, 4)
      .e("div", marko_attrs4, "4", component, 2)
        .n(marko_node3, component)
        .e("input", {
            type: "range",
            id: "fadeout",
            min: "0",
            max: "4095",
            value: "" + data.instrument.fadeout
          }, "6", component, 0)
      .n(marko_node0, component)
      .n(marko_node1, component)
      .n(marko_node2, component);
  }

  out.ee();

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
